import type { IconType } from "react-icons";
import { FaAirbnb, FaFacebookF, FaInstagram, FaTiktok, FaPinterestP, FaGoogle, FaYelp, FaGlobe } from "react-icons/fa";
import { socialProfiles, type SocialPlatform } from "@/lib/social-links";
import { cn } from "@/lib/utils";

const ICONS: Partial<Record<SocialPlatform, IconType>> = {
  airbnb: FaAirbnb,
  facebook: FaFacebookF,
  instagram: FaInstagram,
  tiktok: FaTiktok,
  pinterest: FaPinterestP,
  google: FaGoogle,
  yelp: FaYelp,
};

interface SocialLinksProps {
  className?: string;
  iconClassName?: string;
}

export default function SocialLinks({ className, iconClassName }: SocialLinksProps) {
  if (socialProfiles.length === 0) return null;

  return (
    <ul className={cn("flex flex-wrap items-center gap-3", className)}>
      {socialProfiles.map((profile) => {
        const Icon = ICONS[profile.platform] ?? FaGlobe;
        return (
          <li key={profile.platform}>
            <a
              href={profile.url}
              target="_blank"
              rel="noopener noreferrer me"
              aria-label={profile.label}
              title={profile.label}
              data-testid={`social-link-${profile.platform}`}
              className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-border text-muted-foreground hover:text-primary hover:border-primary transition-colors"
            >
              <Icon className={cn("w-4 h-4", iconClassName)} aria-hidden="true" />
            </a>
          </li>
        );
      })}
    </ul>
  );
}
